import { itemDetailMockupData } from "@/pages/analysis/workTime";
import styled from "@emotion/styled";
import ApexCharts from "react-apexcharts";

interface ChartDataProps {
  itemCode?: string;
}

export const WorkTimeChart = ({ itemCode }: ChartDataProps) => {
  const raw = itemCode ? itemDetailMockupData[itemCode]?.[0] : null;

  const toHourArray = (from: string, to: string): number[] => {
    const start = parseInt(from?.split(":")[0], 10);
    const end = parseInt(to?.split(":")[0], 10);
    return Array.from({ length: 24 }, (_, i) => (i >= start && i < end ? 1 : 0));
  };

  const workTime = raw
    ? toHourArray(raw.workTime?.split("~")[0], raw.workTime?.split("~")[1])
    : new Array(24).fill(0);
  const idleTime = raw ? workTime.map((v) => (v === 1 ? 0 : 1)) : new Array(24).fill(0);
  const onTime = raw
    ? toHourArray(raw.onTime?.split("~")[0], raw.onTime?.split("~")[1])
    : new Array(24).fill(0);
  const moterTime = raw
    ? toHourArray(raw.moterTime?.split("~")[0], raw.moterTime?.split("~")[1])
    : new Array(24).fill(0);

  const series = [
    { name: "기계 가동 시간", type: "line", data: onTime },
    { name: "모터 가동 시간", type: "line", data: moterTime },
    { name: "작업 시간", type: "line", data: workTime },
    { name: "비작업 시간", type: "line", data: idleTime },
  ];

  const xaxisCategories = Array.from(
    { length: 24 },
    (_, i) => `${String(i).padStart(2, "0")}-${String(i + 1).padStart(2, "0")}`,
  );

  const options = {
    chart: {
      height: 350,
      type: "line" as const,
      stacked: false,
    },
    dataLabels: { enabled: false },
    stroke: { width: 2 },
    xaxis: { categories: xaxisCategories },
    yaxis: {
      max: 1,
      tickAmount: 2,
      labels: {
        formatter: (val: number) => (val === 1 ? "On" : "Off"),
      },
    },
  };

  return (
    <Container>
      <ApexCharts options={options} series={series} type="line" height={350} />
    </Container>
  );
};

const Container = styled.div`
  width: 70%;
`;
